import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AnalyticsService } from './core/services/analytics.service';
import { UserStatusService } from './core/services/user-status.service';
import { MemberStatus, UserRole } from './core/services/analytics.events';
import { RegistrationStatus, UserRole as DomainUserRole } from './core/models/user-status.model';
import { EnvBanner } from './shared/components/env-banner/env-banner';

function mapUserRole(role: DomainUserRole | undefined): UserRole | undefined {
  if (role === 'socio') return 'member';
  if (role === 'manager') return 'manager';
  return undefined;
}

function mapMemberStatus(status: RegistrationStatus | undefined): MemberStatus | undefined {
  switch (status) {
    case 'profile_pending':
    case 'accommodation_pending':
    case 'approval_pending':
    case 'approved':
      return status;
    default:
      return undefined;
  }
}

@Component({
  selector: 'app-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, EnvBanner],
  template: `<router-outlet /><app-env-banner />`,
})
export class App {
  private readonly analytics = inject(AnalyticsService);
  private readonly statusService = inject(UserStatusService);

  private previousRegistrationStatus: RegistrationStatus | undefined = undefined;

  constructor() {
    effect(() => {
      const status = this.statusService.userStatus();
      if (!status) {
        return;
      }

      this.analytics.setUserProperties({
        user_role: mapUserRole(status.role),
        member_status: mapMemberStatus(status.registrationStatus),
      });

      const previous = this.previousRegistrationStatus;
      const current = status.registrationStatus;

      if (
        previous !== undefined &&
        previous !== 'approved' &&
        current === 'approved'
      ) {
        this.analytics.logMemberApproved({ approved_at: new Date().toISOString() });
      }

      this.previousRegistrationStatus = current;
    });
  }
}
